import { render, staticRenderFns } from "./SocialAuthButtonsModal.vue?vue&type=template&id=151a5dd9&scoped=true&"
import script from "./SocialAuthButtonsModal.vue?vue&type=script&lang=js&"
export * from "./SocialAuthButtonsModal.vue?vue&type=script&lang=js&"
import style0 from "./SocialAuthButtonsModal.vue?vue&type=style&index=0&id=151a5dd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151a5dd9",
  null
  
)

export default component.exports